import {DAY_TO_DWELLTIME_MAP, REASON_TO_STATUS_MAPPING} from "../dataStore/FilterDataStore"
import {FILTER_DEFAULT} from "../constants/CommonConstants";

/**
 * Function component responsible for initializing filter values based on the context received from parent component and current child context and empty if all empty.
 * This is required to have a central code responsible for filter initializing either with empty or the value.
 * @param {*} selectedFilterValues 
 */

export const FiltersStateInitializer = (selectedFilterValues) => {

        //only when tier 1 to tier 2 takes place
    let [dwellStartTime, dwellEndTime] = []

    if (selectedFilterValues.dwellStartTime && selectedFilterValues.dwellEndTime) {

        dwellStartTime = selectedFilterValues.dwellStartTime.endsWith("_MIN") ? selectedFilterValues.dwellStartTime.split("_MIN")[0] : selectedFilterValues.dwellStartTime.split("_DAY")[0];
        dwellEndTime = selectedFilterValues.dwellEndTime.endsWith("_MIN") ? selectedFilterValues.dwellEndTime.split("_MIN")[0] : selectedFilterValues.dwellEndTime.split("_DAY")[0];
    } else if (selectedFilterValues.dwellStartTime || selectedFilterValues.dwellEndTime ){
        [dwellStartTime, dwellEndTime] = DAY_TO_DWELLTIME_MAP[selectedFilterValues.dwellStartTime  ? selectedFilterValues.dwellStartTime  : selectedFilterValues.dwellEndTime];
    }

    let stationTimeZone = selectedFilterValues.stationTimeZone;
    if (stationTimeZone !== undefined) {
        stationTimeZone = stationTimeZone.replaceAll('%2f', '/');
    }

    return ({
        isOptionsVisible : selectedFilterValues.isOptionsVisible || FILTER_DEFAULT.isOptionsVisible,

        isApplyFilterClicked : selectedFilterValues.isApplyFilterClicked ?  selectedFilterValues.isApplyFilterClicked : FILTER_DEFAULT.isApplyFilterClicked,

        cycles : selectedFilterValues.cycles ? selectedFilterValues.cycles : FILTER_DEFAULT.cycles,

        CPT : selectedFilterValues.CPT ? selectedFilterValues.CPT : FILTER_DEFAULT.CPT,

        startPDD : selectedFilterValues.startPDD !== undefined ? selectedFilterValues.startPDD :  FILTER_DEFAULT.startPDD,

        deliveryWindow : selectedFilterValues.deliveryWindow ? selectedFilterValues.deliveryWindow : FILTER_DEFAULT.deliveryWindow,

        stationTimeZone: stationTimeZone,

        endPDD : selectedFilterValues.endPDD !== undefined ? selectedFilterValues.endPDD :  FILTER_DEFAULT.endPDD,

        shipDateStart : selectedFilterValues.shipDateStart !== undefined ? selectedFilterValues.shipDateStart :  FILTER_DEFAULT.shipDateStart,

        shipDateEnd : selectedFilterValues.shipDateEnd !== undefined ? selectedFilterValues.shipDateEnd :  FILTER_DEFAULT.shipDateEnd,

        //dwell start and end will only be populated in the case of tier 2 change in filters
        dwellStart : selectedFilterValues.dwellStart !== undefined ? selectedFilterValues.dwellStart : dwellStartTime ? dwellStartTime : FILTER_DEFAULT.dwellStart,

        dwellEnd : selectedFilterValues.dwellEnd !== undefined ? selectedFilterValues.dwellEnd : dwellEndTime ? dwellEndTime :  FILTER_DEFAULT.dwellEnd,

        packageTypes : selectedFilterValues.packageTypes ? selectedFilterValues.packageTypes : FILTER_DEFAULT.packageTypes,

        packageTypes_Reverse : selectedFilterValues.packageTypes_Reverse ? selectedFilterValues.packageTypes_Reverse : FILTER_DEFAULT.packageTypes_Reverse,

        packageStatuses : selectedFilterValues.packageStatuses ? Array.from(new Set(selectedFilterValues.packageStatuses.map(status =>
            REASON_TO_STATUS_MAPPING[status] ? REASON_TO_STATUS_MAPPING[status] : status))) :  FILTER_DEFAULT.packageStatuses,

        dwellStartTimeUnit : selectedFilterValues.dwellStartTimeUnit ? selectedFilterValues.dwellStartTimeUnit : 
            (selectedFilterValues.dwellStartTime ? selectedFilterValues.dwellStartTime.endsWith("_MIN") ? "Minutes" : "Day" : FILTER_DEFAULT.dwellStartTimeUnit),

        //Check for 2 thing here  : 
        //1. dwellendunit is not defined which happens from Tier 1 to tier 2
        //2. dwell start and end is not defined which happens in Tier 1
        dwellEndTimeUnit : selectedFilterValues.dwellEndTimeUnit ? selectedFilterValues.dwellEndTimeUnit  : 
            (selectedFilterValues.dwellEndTime ? selectedFilterValues.dwellEndTime.endsWith("_MIN") ? "Minutes" : "Day" : FILTER_DEFAULT.dwellEndTimeUnit),

        sameDay : selectedFilterValues.sameDay ? selectedFilterValues.sameDay : FILTER_DEFAULT.sameDay,

        stationArrivalTime : selectedFilterValues.stationArrivalTime ? selectedFilterValues.stationArrivalTime : FILTER_DEFAULT.stationArrivalTime,

        leg : selectedFilterValues.leg ? selectedFilterValues.leg : FILTER_DEFAULT.leg,

        eadSection : selectedFilterValues.eadSection ? selectedFilterValues.eadSection : FILTER_DEFAULT.eadSection,

        lastUpdatedStart : selectedFilterValues.lastUpdatedStart ? selectedFilterValues.lastUpdatedStart : FILTER_DEFAULT.lastUpdatedStart,

        lastUpdatedEnd : selectedFilterValues.lastUpdatedEnd ? selectedFilterValues.lastUpdatedEnd : FILTER_DEFAULT.lastUpdatedEnd,

        page : selectedFilterValues.page ? selectedFilterValues.page : FILTER_DEFAULT.page,

        enableDwellFilter: selectedFilterValues.enableDwellFilter ? selectedFilterValues.enableDwellFilter : false,

        shipOption : selectedFilterValues.shipOption ? selectedFilterValues.shipOption : FILTER_DEFAULT.shipOption

    })

}


// WEBPACK FOOTER //
// ./src/commons/defaultInitializer/FiltersStateInitializer.js